var map = {
	"./Desert tree.png": 716,
	"./Regular tree.png": 717,
	"./bush_.png": 718,
	"./desert_tree.png": 719,
	"./hard_rock.png": 720,
	"./hell_rock.png": 721,
	"./hell_skull.png": 722,
	"./ocean_anchor.png": 723,
	"./ocean_stick.png": 724,
	"./palm_tree.png": 725,
	"./smooth_rock.png": 726,
	"./snow_rock.png": 727,
	"./tree.png": 728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;